import React from "react";
import { useSelector } from "react-redux";
import LeftSideBar from "../../components/LeftSidebar";
import HomeNav from "./Home";
import styles from "./LeftNavigation.module.scss";
import SearchTeams from "./SearchTeams";
import AddTeam from "./AddTeam";
import WorkWithDesigner from "./WorkWithDesigner";
import Referral from "./Referral";
import { TeamProjects } from "./TeamProjects";

const LeftNavigation = ({ withHeader = true }) => {
  const userInfos = useSelector((state) => state.userInfo);

  return (
    <LeftSideBar withHeader={withHeader}>
      <div className={styles.container}>
        <HomeNav />

        <WorkWithDesigner />

        <Referral />

        {userInfos.canAddTeam && <AddTeam />}

        {userInfos && userInfos.isDesigner && <SearchTeams />}
        <hr />

        <div className={styles.teams}>
          <TeamProjects canAddProject={userInfos.canAddProject} />
        </div>
      </div>
    </LeftSideBar>
  );
};

export default LeftNavigation;
